<p class="bdo-space--top">
  {{ 'feedback.done.description' | translate }}
</p>

<div class="center">
  <button class="bdo-button-primary bdo-space--top" (click)="closeAll()">
    {{ 'feedback.done.close' | translate }}
  </button>
</div>
